module.exports = __webpack_public_path__ + "img/kftb.3f61eac7.png";